import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Flex } from "@chakra-ui/react";

export const PlanDetailsLayout: FC = () => {
  return (
    <Flex align="center" direction="column" minH="100vh" w="100%">
      <Flex align="center" as="main" direction="column" flexGrow={1} w="100%">
        <Outlet />
      </Flex>
    </Flex>
  );
};
